var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAlerta2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 5C19 6.10457 18.1046 7 17 7C15.8954 7 15 6.10457 15 5C15 3.89543 15.8954 3 17 3C18.1046 3 19 3.89543 19 5Z",
    fill: "#FF650F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C11.1614 2 10.4433 2.51616 10.1461 3.24812C7.17983 4.06072 5 6.77579 5 10V14.6972L3.16795 17.4453C2.96338 17.7522 2.94431 18.1467 3.11833 18.4719C3.29235 18.797 3.63121 19 4 19H8.53545C8.77806 20.6961 10.2368 22 12 22C13.7632 22 15.2219 20.6961 15.4646 19H20C20.3688 19 20.7077 18.797 20.8817 18.4719C21.0557 18.1467 21.0366 17.7522 20.8321 17.4453L19 14.6972V10C19 9.1422 18.8457 8.32044 18.5634 7.56095C18.1081 7.83947 17.5728 8 17 8C15.3431 8 14 6.65685 14 5C14 4.42721 14.1605 3.89191 14.439 3.43664C14.2478 3.36554 14.0526 3.30256 13.8539 3.24812C13.5567 2.51616 12.8386 2 12 2ZM12 20C11.3469 20 10.7913 19.5826 10.5854 19H13.4146C13.2087 19.5826 12.6531 20 12 20Z",
    fill: "#1C1F20"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAlerta2);
export default __webpack_public_path__ + "static/media/Ic_Alerta-2.4224c1dc65d42c6bc3af42ec06a7b50e.svg";
export { ForwardRef as ReactComponent };